import mqtt from "mqtt";
import { Commond } from "@/types";

let client: mqtt.MqttClient | null = null;

let BrokerUrl = 'wss://192.168.31.36/mqtt';

if (window.location.hostname !== 'localhost' && window.location.hostname !== '') {
  BrokerUrl = `wss://${window.location.hostname}/mqtt`;
}

const Options: mqtt.IClientOptions = {
  // username: 'your-username',
  // password: 'your-password',
  keepalive: 60,
  reconnectPeriod: 1000,
  clean: true,
};

let Topic = 'meeting/';
let CallBack: Partial<Record<Commond, (payload?: any) => void>> = {}
let TopicCallBack: Record<string, (payload: any, topic: string) => void> = {}
const subscribedTopics = new Set<string>(['meeting']);

const syncSubscriptions = () => {
  if (!client || !client.connected) return;
  subscribedTopics.forEach((topic) => {
    client?.subscribe(topic, (err) => {
      if (err) {
        console.error('MQTT subscribe error:', topic, err);
      } else {
        console.log('MQTT subscribed topic:', topic);
      }
    });
  });
};

/**
 * 订阅主题会议号
 * 全体静音
 * 控制视频终端的音视频开关
 * 踢出
 * 邀请人员
 * 全体摄像头关闭
 */
export const useMqtt = () => {
  const connect = () => {
    console.log('Connecting to MQTT broker...');
    if (!client) {
      client = mqtt.connect(BrokerUrl, Options);

      client.on('connect', () => {
        console.log('MQTT connected');
        syncSubscriptions();
      });

      client.on('reconnect', () => {
        console.log('MQTT reconnecting...');
      });

      client.on('offline', () => {
        console.warn('MQTT offline, waiting to reconnect...');
      });

      client.on('close', () => {
        console.warn('MQTT connection closed, waiting to reconnect...');
      });

      client.on('error', (err) => {
        console.error('MQTT connection error:', err);
      });

      client.on("message", (topic, message) => {
        // message is Buffer
        const str = message.toString();
        try {
          const msgObj = JSON.parse(str);
          const command = msgObj.command as Commond;
          const data = msgObj?.data;
          // console.log(`Received ${topic} ${str}`,CallBack[command]);
          if (command && CallBack[command])
            CallBack[command](data);
          if (TopicCallBack[topic])
            TopicCallBack[topic](data ?? msgObj, topic);
        } catch (e) {
          console.error('Error parsing MQTT message:', e);
        }
      });
    }
  };

  const subscribe = (callback?: (topic: string, message: Buffer) => void) => {
    if (Topic) {
      subscribedTopics.add(Topic);
    }
    if (client) {
      if (!client.connected) return;
      syncSubscriptions();
    }
  }

  const publish = (message: { command: Commond, data?: any } | string, topic?: string) => {
    if (client) {
      if (typeof message !== 'string') {
        message = JSON.stringify(message);
      }
      client.publish(topic || Topic, message);
      console.log("Published message to topic", topic || Topic, message);
    }
  }

  const unSubscribe = () => {
    if (client) {
      publish({ command: Commond.otherLeaveRoom });
      client.unsubscribe(Topic, (err) => {
        // console.log(`Unsubscribing from topic: ${Topic}`);
        subscribedTopics.delete(Topic);
        Topic = 'meeting/';
        subscribedTopics.add(Topic);
        if (err) {
          console.error('MQTT unsubscribe error:', err);
        }
      });
    }
  }

  const disconnect = () => {
    if (client) {
      client.end(true);
      client = null;
    }
  }

  const setTopic = (no: string) => {
    if (Topic !== 'meeting/' || Topic === `meeting/${no}`) return
    Topic = `meeting/${no}`;
    subscribedTopics.add(Topic);
    // console.log(`MQTT topic set to: ${Topic}`);
    subscribe()
  }

  const setCallback = (command: Commond, callback: (payload?: any) => void) => {
    CallBack[command] = callback;
  }

  const setTopicCallback = (topic: string, callback: (payload: any, topic: string) => void) => {
    TopicCallBack[topic] = callback;
    subscribedTopics.add(topic);
    if (client?.connected) {
      client.subscribe(topic, (err) => {
        if (err) {
          console.error('MQTT subscribe error:', topic, err);
        } else {
          console.log('MQTT subscribed topic:', topic);
        }
      });
    }
  }

  const removeTopicCallback = (topic: string) => {
    delete TopicCallBack[topic];
  }

  return {
    connect,
    subscribe,
    unSubscribe,
    publish,
    disconnect,
    setTopic,
    setCallback,
    setTopicCallback,
    removeTopicCallback,
  };
};
